var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pluginName != '')?_c('div',{},[_c('appintegraplugin',{key:_vm.refresh,attrs:{"pluginName":_vm.pluginName}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }